import { generateExcelFileName } from "utils";
import { AssignNotificationChannelsModel, Profile } from "./profileTypes";
import {
  activityWindowColumns,
  alertTypeAssignmentColumns,
  resourceAssignmentColumns,
  notificationChannelMappingColumns,
  profilePropertiesColumns,
} from "./profileConsts";

type SeverityId = 1 | 3 | 5;
export type SeverityString = "Information" | "Warning" | "Critical";

export const SEVERITY_MAP = {
  numbers: new Map<SeverityId, SeverityString>([
    [5, "Critical"],
    [3, "Warning"],
    [1, "Information"],
  ]),
  strings: new Map<SeverityString, SeverityId>([
    ["Critical", 5],
    ["Warning", 3],
    ["Information", 1],
  ]),
};

export const isProfileIncomplete = (profile: Profile) =>
  !profile.resourceAssignments?.length ||
  !profile.alertTypeAssignments?.length ||
  !(
    profile.alertOpenNotificationChannelMappings?.length ||
    profile.alertCloseNotificationChannelMappings?.length
  );

export const getProfileExportConfig = (profile: Profile) => {
  const profileProperties = [
    { property: "Name", value: profile.name },
    { property: "Description", value: profile.description || "" },
    { property: "Time Zone", value: profile.timeZone },
    { property: "System Profile", value: profile.isSystemProfile ? "Yes" : "No" },
    { property: "Can Edit", value: profile.canEdit ? "Yes" : "No" },
    { property: "Can Delete", value: profile.canDelete ? "Yes" : "No" },
    { property: "Read Only Reason", value: profile.readOnlyReason || "" },
    {
      property: "Status",
      value: isProfileIncomplete(profile) ? "Incomplete" : "Operational",
    },
  ];

  return {
    fileName: generateExcelFileName(`profile_${profile.name}`),
    sheets: [
      {
        columns: profilePropertiesColumns,
        data: profileProperties,
        sheetName: "Properties",
      },
      {
        columns: activityWindowColumns,
        data: profile.activityWindows || [],
        sheetName: "Activity Windows",
      },
      {
        columns: resourceAssignmentColumns,
        data: profile.resourceAssignments || [],
        sheetName: "Resources",
      },
      {
        columns: alertTypeAssignmentColumns,
        data: profile.alertTypeAssignments || [],
        sheetName: "Alert Types",
      },
      {
        columns: notificationChannelMappingColumns,
        data: profile.alertOpenNotificationChannelMappings || [],
        sheetName: "Open Notification Channels",
      },
      {
        columns: notificationChannelMappingColumns,
        data: profile.alertCloseNotificationChannelMappings || [],
        sheetName: "Close Notification Channels",
      },
    ],
  };
};
